(function(){
  function init(){
    var box=document.getElementById('OptBuyBox');
    var mbar=document.getElementById('OptPdpBar');
    var fl=document.getElementById('OptPdpFloat');
    if(!box||(!mbar&&!fl))return;
    var last=0;
    function update(){
      var gone=box.getBoundingClientRect().bottom<0;
      if(mbar)mbar.classList.toggle('on',gone);
      if(fl)fl.classList.toggle('on',gone);
    }
    window.addEventListener('scroll',function(){
      var now=Date.now();
      if(now-last>80){last=now;update();}
    },{passive:true});
    window.addEventListener('resize',update,{passive:true});
    update();
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();
